import { gql } from 'apollo-angular';

const SUBMIT_RFP = gql`
  mutation submitRfp($id: Long!) {
    submitRfp(submitRfpRequest: { id: $id }) {
      id
    }
  }
`;

export default SUBMIT_RFP;
